import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlashComponent } from './flash.component';

import { FlashService } from './flash.service';

@NgModule({
  imports: [CommonModule],
  declarations: [FlashComponent],
  exports: [FlashComponent],
  providers: [FlashService]
})
export class FlashModule {}
